import React from 'react';
import { useLocation } from 'react-router-dom';
import DipsList from '../components/dips/DipsList';
import UnifiedMobileFooter from '../components/UnifiedMobileFooter';

const DipsHistoryPage: React.FC = () => {
  const location = useLocation();
  const isFavourites = location.pathname === '/favourites';

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 gap-4">
            <div>
              <h1 className="text-3xl font-bold text-sauna-navy">
                {isFavourites ? 'Your Favourite Dips' : 'Your Dip History'}
              </h1>
              <p className="text-gray-500 mt-1">
                {isFavourites 
                  ? 'View all your dips from your favourite locations.'
                  : 'Track all your sauna sessions and see your progress over time.'
                }
              </p>
              <div className="h-1 w-24 divider-gradient rounded-full mt-2"></div>
            </div>
          </div>
          
          <DipsList showFavouritesOnly={isFavourites} />
        </div>
      </div>
      <UnifiedMobileFooter />
    </>
  );
};

export default DipsHistoryPage; 